var _sodipodiNamedview, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 31.75 31.750002",
    id: "svg1696",
    inkscapeVersion: "1.1.1 (3bf5ae0d25, 2021-09-20)",
    sodipodiDocname: "horses.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1698",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapePageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    "inkscapeDocument-units": "px",
    showgrid: "false",
    inkscapeZoom: 3.1108586,
    inkscapeCx: -2.41091,
    inkscapeCy: 18.162189,
    "inkscapWindow-width": 2560,
    "inkscapeWindow-height": 1377,
    "inkscapeWindow-x": 1912,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "layer1",
    units: "px"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1693"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Ebene 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    style: {
      display: "inline"
    },
    transform: "translate(-0.03787441,-0.00135587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.458676,10.580488 12.809667,9.8897491 11.131503,7.0569434 c 0.175683,0.5729111 0.195086,1.190625 0.04445,1.7808223 -0.105128,0.4176889 -0.242358,0.8357306 -0.399697,1.2527143 l 0.633942,1.07068 c 0.12453,0.209903 0.327025,0.362656 0.563033,0.424039 l 3.018014,0.7874 c 0.07832,0.02011 0.156986,0.02999 0.234245,0.02999 0.411338,0 0.786694,-0.275872 0.89535,-0.692503 0.129116,-0.494947 -0.16757,-1.000477 -0.662164,-1.129594",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7.7003862,14.32346 c 0.9299223,-1.873955 2.1022029,-3.830814 2.5780998,-5.7146471 0.14605,-0.5711473 0.0575,-1.1243028 -0.142522,-1.5652751 -0.2539999,0.065264 -0.5161138,0.099836 -0.782461,0.099836 -0.3421945,0 -0.6794501,-0.057855 -1.001889,-0.1718028 C 7.6661668,6.7281544 7.1243001,6.2529627 6.7630556,5.6528876 6.7605856,5.6525348 6.7577656,5.6521821 6.7552956,5.6514776 6.2430625,5.5318859 5.3928675,6.4928527 4.9102675,7.7438027 4.1697865,9.8795195 3.5898205,12.145059 3.7171735,14.300531 l 3.9832138,0.02293",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path506"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.18195,21.780478 7.3472556,16.572066 4.4005025,16.555486 c 0.03634,0.160866 0.102659,0.318205 0.206728,0.459669 l 4.3137669,5.859287 -0.485775,6.232525 c -0.05327,0.680155 0.4550833,1.27388 1.1345334,1.32715 0.032456,0.0025 0.065264,0.0032 0.097719,0.0032 0.6381752,0 1.1789832,-0.490714 1.2290782,-1.138414 l 0.521759,-6.690456 c 0.02328,-0.295275 -0.06068,-0.589492 -0.236362,-0.827969",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path508"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.719937,4.4001737 C 11.235573,5.7657766 9.8657364,6.5260128 8.6606474,6.0984461 7.4559112,5.6708794 6.8720639,4.2174348 7.3567806,2.8518322 7.8414973,1.4862292 9.2109808,0.72599316 10.415717,1.1535592 c 1.205089,0.427567 1.788583,1.881364 1.30422,3.2466145",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path510"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13.141631,30.124731 v -1.389239 c 2.030942,0 3.902075,-4.998862 4.801306,-7.400573 l 0.136878,-0.365478 c 0.487539,-1.296105 0.777169,-2.222853 0.96908,-2.836686 0.179211,-0.573617 0.278342,-0.890411 0.411339,-1.118658 0.791281,-1.364192 1.696861,-2.156884 2.692048,-2.356556 0.723547,-0.144992 1.456619,0.04269 2.118783,0.544336 1.581503,1.197681 2.321984,1.054453 2.511778,0.981781 0.18415,-0.07056 0.301978,-0.231422 0.349603,-0.478367 0.162278,-0.8382 -1.977673,-3.484033 -3.005667,-4.75615 C 23.258593,9.875638 22.756943,9.2462824 22.548451,8.7986074 22.437326,8.559424 22.347721,8.1322101 22.279987,7.6891212 c -0.254,0.2628194 -0.563386,0.5923139 -0.932744,1.0008306 -0.781403,0.8643056 -2.229203,2.2493112 -3.629378,3.5895142 -0.758473,0.725311 -1.474612,1.411111 -2.021417,1.953331 -2.075745,2.059516 -4.037189,3.0861 -5.9951061,3.137958 L 9.664653,15.981869 c 1.587853,-0.04163 3.24097,-0.936272 5.053189,-2.735086 0.556331,-0.551745 1.276703,-1.241073 2.039761,-1.970617 1.317978,-1.261534 2.811287,-2.6909892 3.559529,-3.5182531 1.423811,-1.5744474 2.006247,-2.0404668 2.068336,-2.0884446 l 1.014941,-0.7895167 0.103364,1.2819945 c 0.06526,0.8103306 0.2032,1.8270362 0.303742,2.0499918 0.146756,0.3150306 0.783872,1.1024306 1.39947,1.8644311 2.024945,2.504016 3.553178,4.528255 3.288947,5.8928 -0.138641,0.71755 -0.582083,1.268236 -1.21673,1.511653 -0.696736,0.2667 -1.929695,0.280105 -3.847043,-1.171928 -0.345369,-0.261408 -0.674511,-0.355953 -1.006475,-0.289278 -0.571147,0.1143 -1.19768,0.715433 -1.764594,1.691217 -0.05433,0.09454 -0.16757,0.45473 -0.286456,0.836789 -0.196497,0.62865 -0.493183,1.577622 -0.994833,2.910769 l -0.136172,0.363714 c -1.162403,3.10515 -3.107973,8.302626 -6.101998,8.302626",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path512"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorses);
export default __webpack_public_path__ + "static/media/horses.dae9e3646ae6530a28cf2d6466983f8d.svg";
export { ForwardRef as ReactComponent };